export const KANBAN_EVENTS = {
    URL_CHANGE: "URL_CHANGE",
    VIEW_PERSON: "view-person",
    EDIT_PERSON: "edit-person",
    NEW_RELATION: "new-relation",
    CREATE_APPOINTMENT: "create-appointment",
    CREATE_TASK: "create-task",
    //
    PROPERTY_EDIT: "edit"
};